module.exports = __webpack_public_path__ + "img/90203794_2785094974906724_7744599480988598272_n.8ad0b42e.png";